import React from 'react';
import { extractRefField } from '../../../../../common/utils/field-options';
import { FieldRow } from './FieldRow';
import { processData } from '../../../../events/action/collection/Util';
import { FieldTypes } from 'drapcode-constant';

export const FieldsMapping = ({ tableRefernceFields, params, collection, handleChange }) => {
  const createNewParamRow = (rowObj) => {
    const newRowObj = processData(tableRefernceFields, rowObj);
    handleChange(params.name, newRowObj);
  };

  let FieldSelectOptions = [];
  const { fields } = collection;
  if (fields.length > 0) {
    // Collection Fields
    const collectionFields = fields
      .filter((field) => FieldTypes.reference.id !== field.type)
      .map((field) => ({
        value: field.fieldName,
        label: field.fieldTitle.en,
      }));
    FieldSelectOptions = [...collectionFields];
  }

  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead style={{ fontWeight: 'bold' }}>
          <tr>
            <td className="text-left" width="30%">
              Header
            </td>
            <td className="text-left" width="26%">
              Fields
            </td>
          </tr>
        </thead>
        <tbody>
          {tableRefernceFields.map((row, index) => (
            <FieldRow
              key={index}
              row={row}
              FieldSelectOptions={FieldSelectOptions}
              createNewParamRow={createNewParamRow}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
